<template>
  <div class="sidebar sidebar-main">
    <div class="sidebar-content">
      <div class="sidebar-category sidebar-category-visible">
        <div class="category-content no-padding">
          <ul class="navigation navigation-main navigation-accordion">
          <li v-for="(item,index) in sidebarListCom" class="sidebar-item" v-if="sidebarListCom[index] && sidebarListCom[index].show" :class="{'active': sidebarListCom[index].set}"  @click="sidebarSet(index)">
            <a href="javascript:void(0)">
              <i :class="sidebarListCom[index].icon" ></i>
              <span class="text">{{sidebarLan[index].text}}</span>
            </a>
          </li>
            </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { URL_SIGNOUT } from '../api/api.js'
  import { Api } from 'api/commissionEnv'
import sidebarList from './../MultiLanguage/menuAllList'
import  {URL_FINDALLPRIVILEGE } from '../api/api.js'
  var api = new Api()

  export default {
    mixins: [
      require("common/mixin/base.js").base({sidebarLan:"sidebarList"})
    ],
    data() {
      return {
        purview: JSON.parse(sessionStorage.user).purview,
        isLogOut: true,
        MenuList:{} ,
        sidebarList: sidebarList
      }
    },
    mounted() {
      this.init_sidebar();
    },
    computed: {
      sidebarListCom() {
        return this.MenuList
      }
    },
    methods: {
      setSidebarActive(sidebarActive) {
        if (sidebarActive == "accountDatum") sidebarActive = "accountList"
        if (sidebarActive == "userDatum") sidebarActive = "userList"
        this.SAVESIDEBARACTIVE(sidebarActive)
      },
      pageInit() {
        //TODO获取页面权限
        // 2019-3-20 更新页面权限，由原先的menuList向rightObject过度
        let _data =[];
        JSON.parse(sessionStorage.rightObject).forEach(item => {
          _data.push(item.right_id);
        })
        let menu = {};
        for(let key in this.sidebarList){
          for(let i in _data){
            if(this.sidebarList[key].Role_ID == _data[i])
            menu[key] =  this.sidebarList[key];
          }
        }
        for (let key in menu){
          menu[key].set = false;
        }
        for (let key in menu){
          menu[key].set = true;
          break;
        }
        this.MenuList = menu;
        // if (this.purview == "customer_service") {
        //   delete this.sidebarList.userList
        //   delete this.sidebarList.dailyReport
        // }
        // this.sidebarSet(this.$route.path.split('/')[1])
      },
      sureFn() {                           //确定退出登录
        this.isLogOut = !this.isLogOut
        this.$http.post(URL_SIGNOUT).then((res) => {
          if(res.data.code=='200'){
            this.SAVEUSER("")
            sessionStorage.user = this.USER

            this.$router.push({
              path: `/login`
            });
          }else{
            alert(res.data.msg)
          }
        })
      },
      sidebarImage(index) {
        return require(`../images/sidebar-_tem${index+1}.png`);
      },
      sidebarSet(index) {
        if (this.sidebarList[index]) {
          let item = this.sidebarList[index]
          if(item.link=='logOut'){
            this.sureFn()
          }else{
            this.setListActive(index)
            this.$router.push({
              path: item.link
            });
          }
        }
      },
      setListActive(index) {
        var keys = Object.keys(this.sidebarList)
        if (keys.indexOf(index) != -1) {
          for(let key in this.sidebarList){
            this.sidebarList[key].set = false
          }
          this.sidebarList[index].set = true;
          this.setSidebarActive(this.sidebarList[index].link)
        }
      },
      // 组件内部使用
      init_sidebar() {
        this.pageInit();
        this.setSidebarActive(this.$route.path.split('/')[1]);
        this.GETSIDEBARVUE(this);
      },
      // 组件外部使用
      Init_SideBar() {
        this.pageInit();
        this.setSidebarActive(this.$route.path.split('/')[1]);
      }
    }
  }
</script>

<style lang="scss" type="text/scss">
  .navigation {
    padding: 0;
  }
  .sidebar{
    background: #fff;
    border-right: 1px solid #ddd;
    .sidebar-item{
      .text{
        position: relative;
        top: 3px;
      }
    }
    .navigation li a{
      color: #333;
    }
    .navigation > li.active > a,.navigation > li.active > a:hover{
      background-color: rgba(0,0,0,0.1);
      color: #333;
    }
    .navigation li a:hover{
      background-color: #f5f5f5;
      color: #333;
    }
    .navigation li a > i{
      margin-top: 4px;
    }
  }

  /*.sidebar{*/
  /*float: left;*/
  /*width: 260px;*/
  /*height: 100%;*/
  /*background: #263238;*/
  /*.sidebar-item{*/
  /*transition: all 0.23s;*/
  /*display: block;*/
  /*height: 44px;*/
  /*line-height: 44px;*/
  /*padding: 0 20px;*/
  /*color: #FFF;*/
  /*font-size: 0px;*/
  /*box-sizing: border-box;*/
  /*cursor: pointer;*/
  /*.sidebar-image{*/
  /*position: relative;*/
  /*vertical-align: top;*/
  /*top: 9px;*/
  /*margin-right: 9px;*/
  /*}*/
  /*.text{*/
  /*font-size: 13px;*/
  /*}*/
  /*}*/
  /*.sidebar-item:hover{*/
  /*background-color: rgba(0,0,0,.1);*/
  /*}*/
  /*.active,.active:hover{*/
  /*background: #26a69a;*/
  /*}*/
  /*}*/

</style>



// WEBPACK FOOTER //
// sidebar.vue?951b3a40